import { render, staticRenderFns } from "./SidebarListReport.vue?vue&type=template&id=6966bbdd"
import script from "./SidebarListReport.js?vue&type=script&lang=js&external"
export * from "./SidebarListReport.js?vue&type=script&lang=js&external"
import style0 from "./SidebarListReport.vue?vue&type=style&index=0&id=6966bbdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports